"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalForm = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const UI_1 = require("../UI");
const ModalForm_1 = require("./ModalForm");
function useModalForm(_a) {
    var _b = _a.form, { onSuccess, onSubmit } = _b, form = tslib_1.__rest(_b, ["onSuccess", "onSubmit"]), { title, Component } = _a, modalProps = tslib_1.__rest(_a, ["form", "title", "Component"]);
    const { useModal } = UI_1.useUIContext();
    const formProps = Object.assign(Object.assign({}, form), { title, onSubmit: (values, formikHelpers) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield onSubmit(values, formikHelpers);
            return result;
        }), onSuccess: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
            useModalResult.closeModal();
        }, closeModal: () => useModalResult.closeModal() });
    if (!Component) {
        Component = ModalForm_1.ModalForm;
    }
    const formElement = jsx_runtime_1.jsx(Component, Object.assign({}, formProps), void 0);
    const useModalProps = Object.assign(Object.assign({}, modalProps), { title, children: formElement });
    const useModalResult = useModal(useModalProps);
    return useModalResult;
}
exports.useModalForm = useModalForm;
//# sourceMappingURL=useModalForm.js.map